import { route } from 'constant'

export const UnauthorizedRoutes = [route.login, route.forgotPassword, route.resetPassword]
